import { render } from "./WeiterButton.vue?vue&type=template&id=06d5defe"
import script from "./WeiterButton.vue?vue&type=script&lang=js"
export * from "./WeiterButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__